import { configureStore } from '@reduxjs/toolkit'
import authReducer from './AuthSlice'
import dataReducer from './DataSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    data: dataReducer,
  },
})